import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ExclamationMarkIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <path d="M10 4L10 11" stroke="currentColor" strokeWidth="inherit" strokeLinecap="round" />
            <path d="M10 15.7L10 15.71" stroke="currentColor" strokeWidth="inherit" strokeLinecap="round" />
        </SvgIcon>
    );
};
